import React, { useState, useEffect } from "react";
import { Users } from "lucide-react";
import CustomerList from '../../../components/Pages/Admin/Customer/CustomerList';
import CustomerDetail from '../../../components/Pages/Admin/Customer/CustomerDetail';
import SummaryStats from '../../merchant/customer/components/SummaryStats';
import { customerService } from '../../../services/apiService';
import { StatsSkeleton } from '../../../services/service';
// Component Skeleton để hiển thị khi đang tải stats

const AdminCustomerManager = () => {
  const [view, setView] = useState("list");
  const [selectedAccount, setSelectedAccount] = useState({customerAccount: null, bankCode: null});
  const [statsData, setStatsData] = useState(null);
  const [loadingStats, setLoadingStats] = useState(true); // State loading riêng cho stats

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setLoadingStats(true);
        const response = await customerService.getGlobalCustomerStats();
        setStatsData(response.data);
      } catch (error) {
        console.error("Lỗi lấy thống kê khách hàng:", error);
      } finally {
        setLoadingStats(false);
      }
    };

    // GỌI TRỰC TIẾP, KHÔNG CẦN SETTIMEOUT NỮA
    fetchStats();
  }, []);

  const handleSelectCustomer = (customer) => {
    setSelectedAccount({customerAccount: customer.customer_account, bankCode: customer.bank_code});
    setView("detail");
  };

  const handleBack = () => {
    setSelectedAccount({customerAccount: null, bankCode: null});
    setView("list");
  };

  const mappedSummary = {
    totalCustomers: statsData?.total_customers || 0,
    totalWithPhone: statsData?.total_phones || 0,
    totalWithMBPhone: statsData?.total_mb_bank_phones || 0,
    totalWithOtherPhone: statsData?.total_non_mb_phones || 0,
    totalMB: statsData?.total_mb_bank || 0,
    totalOther: statsData?.total_non_mb || 0
  };

  return (
    <div className="min-h-screen bg-slate-50 font-sans text-slate-800">
      <header className="bg-white text-black shadow-md top-0 z-40">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="bg-blue-600 p-1.5 rounded-lg">
              <Users size={20} className="text-white" />
            </div>
            <div>
              <h1 className="text-xl font-bold text-slate-900">
                Quản lý khách hàng
              </h1>
            </div>
          </div>
        </div>
      </header>

      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {/* HIỂN THỊ LOADING CHO STATS */}
        {loadingStats ? (
          <StatsSkeleton />
        ) : (
          <SummaryStats summary={mappedSummary} />
        )}

        {view === "list" ? (
          <CustomerList
            onSelect={handleSelectCustomer}
            isParentLoaded={!loadingStats}
          />
        ) : (
          <CustomerDetail
            customerAccount={selectedAccount}
            onBack={handleBack}
          />
        )}
      </main>
    </div>
  );
};

export default AdminCustomerManager;
